import React from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useTimeModal } from '../../Components/TimeModal/TimeModalContext';
import { formatDate, isDatePastInMoscow, formatNull, formatOverflow, formatCaseStatus } from '../../Utils/GlobalUtils';

import Loading from '../../Components/Loading';
import LoadingLines from '../../Components/LoadingLines';
import WarningPanel from '../../Components/WarningPanel';

import Modal from '../Modal';
import SearchUserCases from '../SearchModals/SearchUserCases';

import headerPanel from '../../styles/HeaderPanel.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const AMProcedures = ({ userId }) => {
    const { openTimeModal } = useTimeModal();
    const location = useLocation();
    const navigate = useNavigate();

    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [limitForView, setLimitForView] = React.useState(50);
    const [lastUpdateTime, setLastUpdateTime] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.get(`/api/get-am-cases?user_id=${userId}&limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setWarning('');
            setCases(response.data);
        })
        .catch((error) => {
            console.error(error);
            setWarning(error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее');
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
            setLastUpdateTime(new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }));
        });
    }, [reload, userId]);

    const [isSearch, setIsSearch] = React.useState(false);

    React.useEffect(() => {
        if (window.location.hash === '#search') {
            setIsSearch(true);
        }
    }, []);


    return (
    <>
        <Modal isOpen={isSearch} closeModal={() => { window.location.hash = ''; setIsSearch(false) }}>
            <SearchUserCases userId={userId} />
        </Modal>


        <div className={headerPanel.panel}>
            {/* <button
                type='button' 
                className='button' 
                onClick={() => navigate(`/add-new-case`, { state: { from: location.pathname + location.search + location.hash }})}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z" /></svg>
                Добавить процедуру
            </button> */}
            <div className={headerPanel.searchBtn} onClick={() => { window.location.hash = 'search'; setIsSearch(true) }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" /></svg>
                Поиск...
            </div>
        </div>
      
        <div className='pageWrapper'>
            <div className='tableContainer'>
                <div className='tableHeaderWrapper'>
                    <div className='tableStatus'>
                        <div></div>
                        <a className='lastUpdateWrapper'>
                            Последнее обновление таблицы: {lastUpdateTime || '--:--'} 
                            {loading ? 
                                <Loading type='inline' /> 
                            : 
                                <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                            }
                        </a>
                    </div>
                    <div className='tableHeader' style={{ gridTemplateColumns: '8fr 16fr 14fr 14fr 12fr 16fr 10fr' }}>
                        <div>Номер</div>
                        <div>Процедура / Должники</div>
                        <div>Дата введения процедуры</div>
                        <div>Арбитражный суд</div>
                        <div>Дата судебного заседания о назначении</div>
                        <div>Дата утверждения управляющего АС</div>
                        <div>Статус</div>
                    </div>
                </div>
                {(cases.length===0 && loading) ? <LoadingLines /> 
                : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
                : cases.length === 0 ? <WarningPanel text={'Таблица пуста'} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
                : cases.map((caseItem) =>
                    <motion.div
                        key={caseItem.id}
                        initial={{ scale: '97%', opacity: 0 }}
                        animate={{ scale: '100%', opacity: 1 }}
                        exit={{ scale: '97%', opacity: 0 }}
                        transition={{ duration: 0.3 }}

                        className='tableRow'
                        style={{ gridTemplateColumns: '8fr 16fr 14fr 14fr 12fr 16fr 10fr' }}
                        onClick={() => { 
                            navigate(`/case/${caseItem.id}`, { state: { from: location.pathname + location.search + location.hash }})
                        }}
                    >
                        <div>
                            {formatNull(caseItem.number)} 
                            {caseItem.nameCategory === 'Жалоба' && '(Жалоба)'} 
                            <span className='grayText'>{caseItem.internal_number}</span>
                        </div>
                        <div>
                            <p 
                                className='grayText'
                            >
                                {formatNull(caseItem.procedure_name)}
                            </p>
                            <span className='horizontalLine'></span>
                            {caseItem.debtors ?
                            <p>
                                {formatOverflow(caseItem.debtors.map((e) => e.name).join(', '))}
                            </p>
                            :
                            formatNull(caseItem.debtors)
                            }
                        </div>
                        <div>
                            <div>{formatDate(caseItem.date_procedure_start_m)}<p className='description'>(полная версия)</p></div>
                            <div>{formatDate(caseItem.date_procedure_start_r)}<p className='description'>(рез. часть)</p></div>
                        </div>
                        <div>{formatNull(caseItem.court_name)}</div>
                        <div>
                            {formatDate(caseItem.date_court)}
                        </div>
                        <div>
                            <div>{formatDate(caseItem.date_am_appointment_m)}<p className='description'>(полная версия)</p></div>
                            <div>{formatDate(caseItem.date_am_appointment_r)}<p className='description'>(рез. часть)</p></div>
                        </div>
                        <div>
                            {formatCaseStatus(caseItem.status)}
                        </div>
                    </motion.div>
                )}
                {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
                    <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                        <div></div>
                        <div>
                            <button
                                type='button'
                                className='button'
                                style={{ width: 'fit-content' }}
                                onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                                disabled={loading}
                            >
                                {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                            </button>
                        </div>
                        <div></div>
                    </div>
                )}
            </div>
        </div>
    </>
    )
}

export default AMProcedures;